module.exports = __webpack_public_path__ + "img/App views.ea8a0ead.jpg";